import schedule from '../components/schedule/schedule'

export default {
  schedule
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/resources/components.js